<template>
    <div class="list">
        <div class="list__sort">
            <Toggle :kind="kind" v-if="showToggle"/>

            <a :href="cause.booklet_url" target="_blank" rel="noopener noreferrer" class="btn btn--tertiary btn--memory-booklet" v-if="kind === 'memory' && cause.booklet_url !== null && cause.booklet_url !== ''">
              Yizkor Booklet
            </a>

            <div class="list__search" :class="{ 'list__search--memories': !showToggle }">
                <i class="icon icon-search"></i>
                <input type="text" :placeholder="$t('search')" v-model="search">
            </div>

            <ul class="list__sort-container" v-if="showCrumbs">
                <li>
                    <button class="btn btn--filter" @click="status = 'all'">{{ $t('all') }} <span style="unicode-bidi: bidi-override;">({{data.flat(1).length}})</span></button>
                </li>
                <li>
                    <button class="btn btn--filter" @click="status = 'available'">{{ $t('available') }}
                        <span style="unicode-bidi: bidi-override;">({{available.flat(1).length}})</span>
                    </button>
                </li>
                <li>
                    <button class="btn btn--filter" @click="status = 'sold'">{{ $t('sold') }}
                      <span style="unicode-bidi: bidi-override;">({{sold.flat(1).length}})</span>
                    </button>
                </li>
            </ul>
        </div>
        <div class="list__main">
            <Filters :options="options" :kind="kind" :type="type" v-if="options"/>

            <div class="list__grid" v-click-outside="clearActiveBid" v-if="showItems">
                <div class="col" v-for="(col, i) in filteredItems" :key="i">
                    <Item v-for="(itemData, j) in col" :key="j" :data="itemData" :active="itemData.id === activeItem" :index="itemData.id"/>
                </div>
            </div>

            <div class="list__grid list__grid--memory-items" v-click-outside="clearActiveMemory" v-if="showMemoryItems">
                <div class="col" v-for="(col, i) in filteredItems" :key="i">
                    <Memory v-for="(memoryData, j) in col" :key="j" :data="memoryData" :active="memoryData.id === activeMemory" :index="memoryData.id"/>
                </div>
            </div>

            <div class="list__grid" v-if="showCat">
                <div class="col" v-for="(col, x) in filteredItems" :key="x">
                    <Category v-for="(catData, z) in col" :key="z" :data="catData"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Category from './Category';
  import Item from './Item';
  import Memory from './Memory';
  import Filters from './Filters';
  import Toggle from './Toggle';
  import {chunkArray} from '../../utilities/chunkArray.js';
  import {EventBus} from '../../eventbus';
  import ClickOutside from 'vue-click-outside';
  import { mapState } from 'vuex';

  export default {
    name: 'List',

    components: {
      Item,
      Category,
      Filters,
      Memory,
      Toggle
    },

    directives: {
      ClickOutside
    },

    props: {
      data: Array,
      options: Array,
      kind: String,
      type: String
    },

    computed: {
      ...mapState({
        causes: state => state.causes
      }),
      cause: function () {
        console.log(this.causes.filter((cause) => cause.id === this.$route.params.cause_id)[0]);
        return this.causes.filter((cause) => cause.id === this.$route.params.cause_id)[0];
      },
      showToggle: function () {
        return this.kind === 'prayer' || this.kind === 'action';
      },
      showCrumbs: function () {
        return this.kind === 'prayer' && this.type !== 'cat' || this.kind === 'action' && this.type !== 'cat';
      },
      showCat: function () {
        return this.type === 'cat';
      },
      showItems: function () {
        return this.kind !== 'memory' && this.type === 'items';
      },
      showMemoryItems: function () {
        return this.kind === 'memory' && this.type === 'items';
      },
      route: function () {
        return this.$route.path;
      },
      items: function () {
        return this.data;
      },
      filteredItems: function () {

        let filteredItems = [];

        switch (this.status) {
          case 'all':
            filteredItems = this.items;
            break;
          case 'sold':
            filteredItems = this.sold;
            break;
          case 'available':
            filteredItems = this.available;
        }

        if (this.search !== '') {
          let searchItems = [];

          for (let i = 0; i < filteredItems.length; i++) {
            searchItems = [...searchItems, filteredItems[i].filter((item) => {
              return this.kind === 'memory' ? item && item.name.toLowerCase().includes(this.search.toLowerCase()) : item && item.title.toLowerCase().includes(this.search.toLowerCase());
            })];
          }

          filteredItems = searchItems;
        }

        return filteredItems;
      },
      sold: function () {
        let soldItems = [];

        for (let i = 0; i < this.items.length; i++) {
          soldItems = [...soldItems, this.items[i].filter((item) => item && item.sold)];
        }

        soldItems = soldItems.flat(1);
        const size = Math.ceil(soldItems.length / 2);
        soldItems = chunkArray(soldItems, size);

        return soldItems;
      },
      available: function () {
        let availableItems = [];

        for (let i = 0; i < this.items.length; i++) {
          availableItems = [...availableItems, this.items[i].filter((item) => item && !item.sold)];
        }

        availableItems = availableItems.flat(1);
        const size = Math.ceil(availableItems.length / 2);
        availableItems = chunkArray(availableItems, size);

        return availableItems;
      }
    },

    data: () => {
      return {
        activeItem: null,
        activeMemory: null,
        search: '',
        status: 'all'
      }
    },

    mounted() {
      EventBus.$on('active-item', async (data) => {
        this.activeItem = data === this.activeItem ? null : data;
      });

      EventBus.$on('active-memory', async (data) => {
        this.activeMemory = data === this.activeMemory ? null : data;
      });
    },

    methods: {
      clearActiveBid: function () {
        this.activeItem = null;
      },
      clearActiveMemory: function () {
        this.activeMemory = null;
      }
    }
  }
</script>
